import type { UserContext } from '@zola-helpers/client/dist/es/@types';

export const getIsGuest = (userContext?: UserContext | null) => {
  return userContext ? Boolean(userContext.is_guest) : true;
};
